var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _vm.getFormConfig
      ? _c("div", { attrs: { slot: "header" }, slot: "header" }, [
          _c("span", {
            domProps: {
              innerHTML: _vm._s(_vm.clearPLabel(_vm.getFormConfig.label)),
            },
          }),
        ])
      : _vm._e(),
    _vm.getBrandIdData
      ? _c(
          "div",
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.brandId,
                  callback: function ($$v) {
                    _vm.brandId = $$v
                  },
                  expression: "brandId",
                },
              },
              _vm._l(_vm.getBrandIdData.options, function (item, index) {
                return _c(
                  "el-radio",
                  { key: index, attrs: { label: item.value } },
                  [_vm._v("\n\t\t\t\t" + _vm._s(item.label) + "\n\t\t\t")]
                )
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }